export default function () {
  this.getTowers()
}



// WEBPACK FOOTER //
// ./src/app/tenant/unit/form/resources/mounted.js